// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalAccess = {
  accessPortalBaseUrl: "Portal URL",
  accessLoginMode: "Login Mode",
  accessAccountCenterUrl: "Account Center URL",
  accessDefaultRedirectPath: "Default Redirect Path",
  accessShowHealthStatus: "Show Health Status",
  accessShowAccountCenter: "Show Account Center Entry",
  accessTitle: "Portal Access Policy",
  accessSubtitle: "Review Endpoint Registry-derived entries and manage Portal runtime policy.",
  accessNotice:
    "Portal addresses, domains, and ports are managed by the Endpoint Registry; this page only manages redirects and Portal display policy.",
  accessEndpointTitle: "Registry-Derived Entries (Read Only)",
  accessEndpointSource: "Entry Source",
  accessEndpointSourceValue: "Endpoint Registry · deploy/service-endpoints.json",
  accessEndpointReadOnlyNotice:
    "Entry addresses, domains, and ports cannot be edited here. Update the Endpoint Registry and regenerate runtime configuration instead.",
  accessPolicyTitle: "Portal Runtime Policy",
  accessAccountCenterUrlUnavailable: "Not provided",
} as const;
